export default __webpack_public_path__ + "static/media/pexelsdictionary.2543d385.jpeg";